import { makeVar } from "@apollo/client";

export const isRefetchBranches = makeVar<boolean>(false);
export const branchesLength = makeVar<number | null>(null);
export const branchNameState = makeVar<string | null>(null);
